/**
 * Добавляет ведущий слэш к строке, если он отсутствует.
 *
 * @param {string} url Строка, к которой нужно добавить ведущий слэш.
 * @return {string} Строка с ведущим слэшем.
 */
function addLeadingSlash(url: string): string {
  return url.charAt(0) === '/' ? url : `/${url}`
}

export {addLeadingSlash}
